export default __webpack_public_path__ + "static/media/SmallMail.364f9d7e.svg";